import { createFeatureSelector, createSelector } from '@ngrx/store';

import { VppApplicationsState } from './vpp-applications.state';
import * as fromVppApplications from './vpp-applications.reducer';

export const selectVppApplicationsState = createFeatureSelector<VppApplicationsState>('vppApplications');

export const selectAllVppApplications = createSelector(
  selectVppApplicationsState,
  fromVppApplications.selectAllVppApplications
);
